// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/book-open.js';

import { paths } from '../generated/book-open';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('book-open', Original, paths);
